var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var GlobalNodeElement_1;
import { JSON, JsonSchema } from '@symon-ai/wisepipe-serialize';
import './toolConfig'; // force import for JsonSchema
import { ToolType } from '@symon-ai/wisepipe-base-pipe';
import { NodeElement } from './nodeElement';
import { GraphElement } from './graphElement';
// GlobalNodeElement is used by incentives for retrieving node information across all pipes
const schema = {
    $id: 'urn:wisepipe-common-pipe:GlobalNodeElement',
    type: 'object',
    properties: {
        nameOverride: { type: 'string' },
        pipeID: { type: 'string', uid: 10 }
    },
    if: {
        required: ['config']
    },
    then: {
        properties: {
            config: { $ref: 'urn:wisepipe-common-pipe:ToolConfig' },
            toolType: { type: 'string', const: { $data: '1/config/toolType' } }
        }
    },
    else: {
        properties: {
            toolType: {
                type: 'string',
                // build a list of valid tooltypes, except ToolType.NONE
                enum: Object.keys(ToolType)
                    .map((key) => ToolType[key])
                    .filter((key) => typeof key !== 'function' && key !== ToolType.NONE)
            }
        }
    },
    required: ['pipeID', 'toolType']
};
let GlobalNodeElement = GlobalNodeElement_1 = class GlobalNodeElement extends GraphElement {
    constructor(pipeID, elementID, toolType, config, lastModified, nameOverride, uniqueChangeID) {
        super(elementID, 'node', lastModified, uniqueChangeID);
        this.pipeID = pipeID;
        this.toolType = toolType;
        const actual = config || this.getDefaultConfig();
        if (actual)
            this.config = actual;
        if (nameOverride)
            this.nameOverride = nameOverride;
        JSON.validate(this, GlobalNodeElement_1);
    }
    getDefaultConfig() {
        return NodeElement.getDefaultConfig(this.toolType);
    }
    getName() {
        return NodeElement.getName(this.toolType, this.nameOverride);
    }
};
GlobalNodeElement = GlobalNodeElement_1 = __decorate([
    JsonSchema(schema)
], GlobalNodeElement);
export { GlobalNodeElement };
//# sourceMappingURL=globalNodeElement.js.map